import React from 'react';

const IconClientExit = ({ onClick = () => {} }) => {
  return (
    <div onClick={onClick}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 4.82166L10.125 0.696655L11.3033 1.87499L7.17834 5.99999L11.3033 10.125L10.125 11.3033L6 7.17832L1.875 11.3033L0.696671 10.125L4.82167 5.99999L0.696671 1.87499L1.875 0.696655L6 4.82166Z"
          fill="#455976"
        />
      </svg>
    </div>
  );
};

export default IconClientExit;
